module.exports = __webpack_public_path__ + "static/media/nexone-award.a881ccf9.png";